import { type FC } from 'react';
import {
  UserCircle
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconUserCircleProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconUserCircle: FC<UiIconUserCircleProps> = (props) => {
  return (
    <UiIcon
      IconComponent={UserCircle}
      {...props}
    />
  );
};
